export default __webpack_public_path__ + "static/media/File_No_1.4ad2dd56.pdf";